import React from 'react';

import {Site} from 'src/lib/api/project';
import {addDays} from 'src/lib/dates';
import {hasGaugeElevation, hasGaugeFlow, makeStringFromDate} from 'src/lib/siteUtils';
import * as tw from 'src/lib/tailwindClasses';

import ElevationGauge from './ElevationGauge';
import FlowGauge from './FlowGauge';

export default function Gauges({site}: {site: Site}) {
  const [dateRange, setDateRange] = React.useState<[Date, Date]>([
    addDays(new Date(), -30),
    addDays(new Date(), +10),
  ]);

  return (
    <div className={tw.section}>
      <div className={tw.sectionHeader}>
        <h2 className={tw.sectionTitle}>Gauge observations</h2>
        <div className="flex items-center flex-wrap gap-2">
          <input
            className={`h-8 px-2 py-1 rounded-md ${tw.ringBorder}`}
            type="date"
            value={makeStringFromDate(dateRange[0], site.localTimeZone)}
            onChange={(e) => setDateRange([new Date(e.target.value), dateRange[1]])}
          />
          <p>to</p>
          <input
            className={`h-8 px-2 py-1 rounded-md ${tw.ringBorder}`}
            type="date"
            value={makeStringFromDate(dateRange[1], site.localTimeZone)}
            onChange={(e) => setDateRange([dateRange[0], new Date(e.target.value)])}
          />
        </div>
      </div>
      {hasGaugeFlow(site) && (
        <FlowGauge site={site} dateRange={dateRange} setDateRange={setDateRange} />
      )}
      {hasGaugeElevation(site) && (
        <ElevationGauge site={site} dateRange={dateRange} setDateRange={setDateRange} />
      )}
    </div>
  );
}
